module.exports = __webpack_public_path__ + "static/media/LV-CHF.4390e9d9.jpg";